require('../../modules/es7.array.includes');
module.exports = require('../../modules/_core').Array.includes;



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/fn/array/includes.js